import "./ProductFeatureCard.css";
import { Heading } from "@tennr/frontend/components/Heading";
import { Button } from "@tennr/frontend/components/Button";
import { Portal } from "@tennr/frontend/components/Portal";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface ProductFeatureCardProps {
  title: string;
  heading: string;
  body: string;
  ctaText: string;
  expandedContent?: React.ReactNode;
}

export const ProductFeatureCard: React.FC<ProductFeatureCardProps> = ({
  title,
  heading,
  body,
  ctaText,
  expandedContent,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="product-feature-card">
      <Heading heading={heading} title={title} body={body} position="left" color="dark" variant="tertiary" />
      <Button
        minHeight="71px"
        // text={isExpanded ? "- HIDE" : ctaText}
        text={ctaText}
        onClick={handleToggle}
        ctaPlus={true}
        isExpanded={isExpanded}
      />
      <AnimatePresence>
        {isExpanded && expandedContent && (
          <Portal>
            <motion.div
              className="product-feature-expanded-overlay"
              onClick={handleToggle}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <motion.div
                className="product-feature-expanded"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
              >
                {expandedContent}
              </motion.div>
            </motion.div>
          </Portal>
        )}
      </AnimatePresence>
    </div>
  );
};
